// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"1fd05948","390":"70dcc7c4","776":"5d159a65"}[chunkId] + ".chunk.js";
};